<template>
  <div class="u-input custom-validate-input">
    <div class="u-input-box" :class="[{'is-not-valid': !data.isValid || inValid, 'disabled': disabled, 'force-value': forceValue}, classes || {}]" :style="getStyles">
<!--      <span class="input-label" :class="{'is-focus': (data.value || '').toString().length || label.length}">{{ labelPlaceholder || label }}</span>-->

      <div class="u-input-label-box">
        <div class="u-input-label-box-start"></div>
        <div v-if="labelPlaceholder || label" class="u-input-label-box-center" :class="[labelPosition]">
          <span class="u-input-label text-subtitle" :class="[{'is-focus': data.value.toString().length || label, 'text-body-1': labelPosition === 'inside'}]">{{ labelPlaceholder || label }}</span>
        </div>
        <div class="u-input-label-box-end"></div>
      </div>
      <div v-if="disabled"
           class="disable-input-value disabled"
           :class="[{'text-primary has-link': Object.values(this.route).length > 0 || enableCopy}, align === 'right' ? 'text-left' : 'text-right', {'rtl': !rtl}, {'ltr': rtl}, value.class || '']"
           @click="handleClickInput">
        {{ data.value }}
      </div>
      <input v-else
             type="text"
             ref="inputEl"
             :class="[align === 'right' ? 'text-left' : 'text-right', value.class || '', {'disabled': disabled, 'force-value': forceValue, 'text-primary has-route': Object.values(this.route).length > 0}, {'rtl': !rtl}, {'ltr': rtl}]"
             @input="handleInputValue"
             @click="handleClickInput"
             @contextmenu="handleContextMenuClicked($event)"
             @keydown.enter="handleKeydownEnter"
             :autocomplete="'new-password'"
             :name="Math.random()"
             :placeholder="placeholder || ''"
             :disabled="disabled"
             v-model="data.value">
    </div>
    <span class="u-input-errors" v-if="(!data.isValid || inValid) && this.data.value.length > 0" >
      {{ invalidText }}
    </span>

  </div>
</template>

<script>
export default {
  name: 'customValidateInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    rtl: {
      type: Boolean,
      default: () => { return true }
    },
    disabled: {
      type: Boolean,
      default: () => { return false }
    },
    setPageChange: {
      type: Boolean,
      default: () => { return true }
    },
    label: {
      type: String,
      default: () => { return '' }
    },
    placeholder: {
      type: String,
      default: () => { return '' }
    },
    labelPlaceholder: {
      type: String,
      default: () => { return '' }
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    align: {
      type: String,
      default: () => { return 'right' },
      validator (value) {
        return ['right', 'left', 'center'].includes(value)
      }
    },
    isEmpty: {
      type: Boolean,
      default: () => { return false }
    },
    inValid: {
      type: Boolean,
      default: () => { return false }
    },
    enableCopy: {
      type: Boolean,
      default: () => { return false }
    },
    regex: {
      type: RegExp,
      default: () => { return null }
    },
    route: {
      type: Object,
      default () {
        return {}
      }
    },
    forceValue: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default () { return {} }
    },
    invalidText: {
      type: String,
      default: () => { return '' }
    },

    classes: {
      type: [Object, Array, String],
      default () { return {} }
    },
    styles: {
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      data: {
        value: '',
        isValid: false
      }
    }
  },
  computed: {
    getStyles () {
      const styles = JSON.parse(JSON.stringify(this.styles))
      if (!styles.width) {
        // styles.width = '230px'
      }

      return styles
    }
  },
  created () {
    if (Object.keys(this.value).length) {
      this.initValues()
    }
    if (this.isEmpty) {
      this.data.isValid = true
    } else {
      this.validateValue()
    }
  },
  mounted () {
    if (this.autoFocus) {
      this.handleFocusInput()
    }
  },
  methods: {
    handleInputValue () {
      if (this.forceValue) {
        this.data.value = this.value.value
      } else {
        // this.data.value = this.$u.trim(this.data.value.toString().replace(this.regex, ''))
        this.validateValue()
        if (this.setPageChange) {
          this.$store.dispatch('setPageChanges')
        }
        this.$emit('input', {value: this.data.value.toString().replaceAll(',', ''), isValid: this.data.isValid})
      }
    },
    validateValue () {
      if (this.regex !== null && this.data.value !== '') {
        this.data.isValid = this.regex.test(this.data.value)
      } else if (this.isEmpty) {
        this.data.isValid = true
      } else {
        this.data.isValid = this.data.value.toString().length > 0
      }
    },
    initValues () {
      this.data.value = this.value.value || ''
      this.validateValue()
    },
    handleContextMenuClicked (event) {
      const payload = {
        actions: {
          clipboard: this.data.value,
          paste: true
        },
        event
      }
      this.$store.dispatch('helper/contextMenuClicked', payload)
    },
    handleClickInput () {
      if (Object.values(this.route).length > 0) {
        window.open(this.$router.resolve(this.route).href, '_blank')
      } else {
        this.$emit('clicked')
      }
    },
    handleKeydownEnter () {
      this.$emit('pressEnter')
    },
    handleFocusInput () {
      setTimeout(() => {
        const inputEl = this.$refs.inputEl
        if (inputEl) {
          inputEl.focus()
        }
      }, 100)
    }
  },
  watch: {
    value: {
      handler () {
        this.initValues()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-validate-input {
  position: relative;
}
</style>
